import { createSlice } from '@reduxjs/toolkit'

const passwordStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    status: null,
    errorMessage: null,
}

const accountPasswordSlice = createSlice({
    name: 'account/password',
    initialState,
    reducers: {
        resetPasswordRequest: state => {
            state.status = passwordStatus.LOADING
        },
        resetPasswordRequestSuccess: (state, action) => {
            state.status = passwordStatus.SUCCESS
        },
        resetPasswordRequestError: (state, action) => {
            state.status = passwordStatus.FAILURE
            state.errorMessage = action.payload
        },
        resetState: state => initialState,
    },
})

const {
    resetPasswordRequest,
    resetPasswordRequestSuccess,
    resetPasswordRequestError,
    resetState,
} = accountPasswordSlice.actions

export const passwordActions = {
    resetPasswordRequest,
    resetPasswordRequestSuccess,
    resetPasswordRequestError,
    resetState,
}

export const passwordSelectors = {
    isFetching: state =>
        state.accountPassword.status === passwordStatus.LOADING,
    hasError: state => state.accountPassword.status === passwordStatus.FAILURE,
    success: state => state.accountPassword.status === passwordStatus.SUCCESS,
    errorMessage: state => state.accountPassword.errorMessage,
}

export default accountPasswordSlice.reducer
